import React from 'react'

import {helpersTableSchema} from './EntityHelpersTableSchema'
import Tooltip from '@material-ui/core/Tooltip'

import LockIcon from '@material-ui/icons/Lock'

function getTooltip( entity,field,header,placement = 'bottom' ) {
    const entityTooltips = helpersTableSchema(entity)
    const tooltip = entityTooltips.hasOwnProperty(field)
        ? entityTooltips[field]
        : header

    return <Tooltip placement={placement} title={tooltip}><span>
        {header}
    </span></Tooltip>
}

export function tableSchema( entity ) {
    switch (entity) {
        case 'users':
            return {
                user_pass: {
                    Header: "Password",
                    Cell: (props) => {
                        return <LockIcon color="secondary" fontSize="small" />
                    },
                    filterable: false,
                },
            }
        default:
            return {}
    }
}
